import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
const TITLE = "Berapa Hari Lagi Idul Adha 2026 - Hitung Mundur Idul Adha 2026";
const DESCRIPTION = "Berapa hari lagi Idul Adha, Idul Adha 2026, kapan Idul Adha, berapa hari lagi Idul Adha, kapan Idul Adha 2026, tanggal Idul Adha 2026, jadwal Idul Adha 2026, berapa hari lagi Idul Adha 2026, Idul Adha 2024, berapa hari lagi Idul Adha, berapa hari lagi kurban, Idul Adha 2026, berapa hari lagi Idul Adha 2026, jadwal Idul Adha 2024, tanggal Idul Adha, kapan Idul Adha, berapa hari lagi hari kurban, kapan wukuf Arafah 2026, jadwal Idul Adha, berapa hari lebaran Idul Adha, Idul Adha, tanggal Idul Adha, lebaran Idul Adha, berapa hari lagi Idul Adha, Idul Adha 2026, 1447 Hijriah, berapa hari lagi Idul Adha 2026, sisa hari Idul Adha, berapa lama lagi Idul Adha 2026, jadwal Idul Adha 2026, Idul Adha Mubarak, tanggal Idul Adha 2026, berapa hari lagi Idul Adha, Idul Adha 2026";
const KEYWORDS = "berapa hari lagi Idul Adha, Idul Adha 2026, kapan Idul Adha, berapa hari lagi kurban, kapan Idul Adha 2026, tanggal Idul Adha 2026, jadwal Idul Adha 2026, berapa hari lagi Idul Adha 2026, Idul Adha 2024, hitung mundur Idul Adha, lebaran Idul Adha 2026, berapa hari lagi hari raya Idul Adha";
const OG_URL = "https://do-calculate.com/articles-id/eid-adha";
function EidAdha() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const initialDate = new Date("2026-05-27T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(initialDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    const ramadanDates = [
        { name: 'Idul Adha 2026', date: new Date("2026-05-27T00:00:00") },
        { name: 'Idul Adha 2027', date: new Date("2027-05-17T00:00:00") },
        { name: 'Idul Adha 2028', date: new Date("2028-05-05T00:00:00") },
        { name: 'Idul Adha 2029', date: new Date("2029-04-24T00:00:00") }
    ];
    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Berapa Hari Lagi Idul Adha 2026
            </h1>
            <div>
                <BlinkingText text="Berapa hari lagi Idul Adha: Diperkirakan Idul Adha 2026 dimulai hari Rabu tanggal 27/05/2026 Masehi dan 10/12/1446 menurut kalender Hijriah." />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Hari</th>
                                <th className="bmi-header">Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Jadwal Idul Adha Mendatang</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jadwal Idul Adha</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Tanggal</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Sisa Hari</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('en-GB')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(ramadan.date).days} hari</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Idul Adha 2026</h3>
                    <p>
                        Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju Idul Adha yang mulia, agar Anda selalu mengetahui berapa hari lagi hari raya yang penuh berkah ini tiba. Banyak di antara kita yang bertanya berapa hari lagi Idul Adha, oleh karena itu kami hadirkan hitung mundur Idul Adha agar Anda dapat mengetahui berapa hari lagi Idul Adha, berapa hari tersisa hingga Idul Adha. Lihat hitung mundur Idul Adha di atas.
                    </p>
                    <p>
                        Berdasarkan situs <a href='/calculator/id/gregorian_to_hijri/'>konversi tanggal</a>, Idul Adha 2026 bertepatan dengan hari Rabu 27/05/2026 Masehi dan 10/12/1446 Hijriah. Anda dapat melihat hitung mundur Idul Adha 2026 di artikel ini.
                    </p>
                    <p>Temukan di sini hitung mundur Idul Adha, di mana Anda dapat mengetahui berapa hari lagi Idul Adha yang mulia.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Hitung Berapa Hari Lagi Idul Adha
                    </h3>
                    <p>
                        Melalui program hitung mundur Idul Adha, Anda dapat mengetahui berapa hari lagi Idul Adha dalam kalender Masehi maupun Hijriah, serta mengetahui sisa hari menuju Idul Adha dalam hitungan hari, kapan Idul Adha tiba, dan jadwal Idul Adha yang mulia tahun ini. Semoga kita semua diberikan keberkahan di hari raya yang agung ini.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Idul Adha
                    </h3>
                    <p>
                        Idul Adha adalah salah satu dari dua hari raya umat Islam (hari raya lainnya adalah Idul Fitri). Idul Adha jatuh pada tanggal 10 Dzulhijjah setelah berakhirnya Wukuf di Arafah, yaitu saat para jamaah haji Muslim berdiri untuk menunaikan rukun haji yang paling penting, dan berakhir pada tanggal 13 Dzulhijjah.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Berapa hari lagi Idul Adha"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Cara Umat Islam Merayakan Idul Adha yang Mulia
                    </h3>
                    <p>
                        Pada Idul Adha, umat Muslim di seluruh penjuru dunia menunaikan ibadah dan syiar keagamaan tertentu. Kebahagiaan menyebar, kita mengunjungi keluarga dan orang-orang yang kita cintai, dan yang berkecukupan membantu yang membutuhkan di hari agung ini. Hari-hari raya dimulai dari tanggal 10 Dzulhijjah hingga tanggal 13 bulan yang sama.
                    </p>
                    <ul>
                    </ul>
                </div>
                <br />
            </div>
        </div>
    );
}
export default EidAdha;
